export function getSubNavigationItems (
  { showImportLink = false, activeTab = 'shipments', shipmentId = undefined, isSales = false }
) {
  const navigationItems = []

  if (isSales) {
    navigationItems.push({
      title: 'Completed',
      path: '/shipments/completed',
      active: (activeTab === 'completed')
    })
  } else {
    navigationItems.push(
      {
        title: 'Scheduled/incoming',
        path: '/shipments/list',
        active: (activeTab === 'shipments')
      },
      {
        title: 'Completed',
        path: '/shipments/completed',
        active: (activeTab === 'completed')
      }
    )
  }

  if (showImportLink) {
    navigationItems.push(
      {
        title: shipmentId ? 'Edit Shipment' : 'New Shipment',
        path: shipmentId ? `/${shipmentId}/edit` : '/shipments/new',
        active: (activeTab === 'new')
      },
      {
        title: 'Import',
        path: '/shipments/import',
        active: (activeTab === 'import')
      }
    )
  }
  return navigationItems
}
